webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var BASE_URL = '//imeicheck.pro/api/';

if (window.location.hostname.includes("mate")) {
  BASE_URL = '//imeimate.com/api/';
}

if (window.location.hostname.includes("fit")) {
  BASE_URL = '//imei.fit/api/';
}

if (window.location.hostname.includes("unlockhost")) {
  BASE_URL = '//unlockhost.com/api/';
}

BASE_URL = window.location.protocol + BASE_URL;

var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: BASE_URL,
  timeout: false,
  params: {} });

instance.interceptors.request.use(function (config) {
  var token = Store.state.user.token;

  if (token) {
    config.headers.common['Authorization'] = 'Bearer ' + token;
    config.headers.common['Access-Control-Allow-Origin'] = '*';
  } else {
    config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
    config.headers.common['AppVer'] = '1.7';
  }

  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  getData: function getData(action) {
    var url = '' + BASE_URL;
    url += action;
    return instance.get(url);
  },
  getDataByURL: function getDataByURL(url) {
    return instance.get(url);
  },
  postData: function postData(action, data) {
    var url = '' + BASE_URL;
    url += action;
    return instance.post(url, data);
  },
  postDataByURL: function postDataByURL(url, data) {
    return instance.post(url, data);
  },
  putData: function putData(action, data) {
    var url = '' + BASE_URL;
    url += action;
    return instance.put(url, data);
  },
  deleteData: function deleteData(action) {
    var url = '' + BASE_URL;
    url += action;
    return instance.delete(url);
  },
  login: function login(action, data) {
    var url = '' + BASE_URL;
    url += action;
    return instance.post(url, data);
  },
  logout: function logout() {
    var url = '' + BASE_URL;
    url += "logout.php";
    return instance.get(url);
  }
});

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(399),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(409),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Dashboard__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_OrderList__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_OrderList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_OrderList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_PlaceOrder__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_PlaceOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_PlaceOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_OrderHistory__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_OrderHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_OrderHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_AddCredits__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_AddCredits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_AddCredits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Parser__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_APISettings__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_APISettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_APISettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Login__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_auth__ = __webpack_require__(31);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);



function requireAuth(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_11__utils_auth__["a" /* default */].loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: __dirname,
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{ path: '/404', component: __WEBPACK_IMPORTED_MODULE_2__components_404___default.a, name: 'ErrorPage' }, { path: '/dashboard', component: __WEBPACK_IMPORTED_MODULE_3__pages_Dashboard___default.a, name: 'Dashboard', beforeEnter: requireAuth }, { path: '/orders', component: __WEBPACK_IMPORTED_MODULE_4__pages_OrderList___default.a, name: 'WorkJobs', beforeEnter: requireAuth }, { path: '/neworder', component: __WEBPACK_IMPORTED_MODULE_5__pages_PlaceOrder___default.a, name: 'PlaceOrder', beforeEnter: requireAuth }, { path: '/history', component: __WEBPACK_IMPORTED_MODULE_6__pages_OrderHistory___default.a, name: 'OrderHistory', beforeEnter: requireAuth }, { path: '/parser', component: __WEBPACK_IMPORTED_MODULE_8__pages_Parser___default.a, name: 'Parser', beforeEnter: requireAuth }, { path: '/credits', component: __WEBPACK_IMPORTED_MODULE_7__pages_AddCredits___default.a, name: 'AddCredits', beforeEnter: requireAuth }, { path: '/apisetup', component: __WEBPACK_IMPORTED_MODULE_9__pages_APISettings___default.a, name: 'API', beforeEnter: requireAuth }, { path: '/login', component: __WEBPACK_IMPORTED_MODULE_10__components_Login___default.a, name: 'Login' }, { path: '/logout',
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_11__utils_auth__["a" /* default */].logout();
      next('/login');
    }
  }, { path: '/', redirect: '/dashboard' }, { path: '*', redirect: '/404' }],
  meta: {
    progress: {
      func: [{ call: 'color', modifier: 'temp', argument: '#ffb000' }, { call: 'fail', modifier: 'temp', argument: '#6e0000' }, { call: 'location', modifier: 'temp', argument: 'top' }, { call: 'transition', modifier: 'temp', argument: { speed: '1.5s', opacity: '0.6s', termination: 400 } }]
    }
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var SearchFilterOps = {
  Equals: '',
  GreaterThan: '_gte',
  LessThan: '_lte',
  GreaterThanOrEqual: '_gte',
  LessThanOrEqual: '_lte',
  Contains: '_like',
  StartsWith: '_like',
  EndsWith: '_like',
  Between: ''
};

/* harmony default export */ __webpack_exports__["a"] = ({
  capFirstLetter: function capFirstLetter(s) {
    return s && s[0].toUpperCase() + s.slice(1);
  },
  clearSearchFilters: function clearSearchFilters(searchVm) {
    if (searchVm) {
      if (searchVm.filters) delete searchVm.filters;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(searchVm).forEach(function (K) {
        if (searchVm[K]) {
          if (K !== "between") {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(searchVm[K]).forEach(function (prop) {
              searchVm[K][prop] = null;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(searchVm[K]).forEach(function (prop) {
              searchVm[K][prop]["former"] = 0;
              searchVm[K][prop]["latter"] = 0;
            });
          }
        }
      });
    }
  },
  buildSearchFilters: function buildSearchFilters(searchVm) {
    if (searchVm) {
      searchVm.filters = [];
      if (searchVm.contains) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(searchVm.contains).forEach(function (k) {
          if (searchVm.contains.hasOwnProperty(k) && searchVm.contains[k]) {
            searchVm.filters.push({
              property: k,
              op: SearchFilterOps.Contains,
              val: searchVm.contains[k]
            });
          }
        });
      }

      if (searchVm.equals) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(searchVm.equals).forEach(function (k) {
          if (searchVm.equals.hasOwnProperty(k) && searchVm.equals[k]) {
            searchVm.filters.push({
              property: k,
              op: SearchFilterOps.Equals,
              val: searchVm.equals[k]
            });
          }
        });
      }

      if (searchVm.startsWith) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(searchVm.startsWith).forEach(function (k) {
          if (searchVm.startsWith.hasOwnProperty(k) && searchVm.startsWith[k]) {
            searchVm.filters.push({
              property: k,
              op: SearchFilterOps.StartsWith,
              val: searchVm.startsWith[k]
            });
          }
        });
      }

      if (searchVm.endsWith) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(searchVm.endsWith).forEach(function (k) {
          if (searchVm.endsWith.hasOwnProperty(k) && searchVm.endsWith[k]) {
            searchVm.filters.push({
              property: k,
              op: SearchFilterOps.EndsWith,
              val: searchVm.endsWith[k]
            });
          }
        });
      }

      if (searchVm.between) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(searchVm.between).forEach(function (k) {
          if (searchVm.between.hasOwnProperty(k) && searchVm.between[k]) {
            if (searchVm.between[k]["former"] > 0 || searchVm.between[k]["latter"] > 0) {
              if (searchVm.between[k]["former"] < searchVm.between[k]["latter"]) {
                searchVm.filters.push({
                  property: k,
                  op: SearchFilterOps.GreaterThanOrEqual,
                  val: searchVm.between[k]["former"]
                });
                searchVm.filters.push({
                  property: k,
                  op: SearchFilterOps.LessThanOrEqual,
                  val: searchVm.between[k]["latter"]
                });
              } else {
                searchVm.filters.push({
                  property: k,
                  op: SearchFilterOps.LessThanOrEqual,
                  val: searchVm.between[k]["former"]
                });
                searchVm.filters.push({
                  property: k,
                  op: SearchFilterOps.GreaterThanOrEqual,
                  val: searchVm.between[k]["latter"]
                });
              }
            }
          }
        });
      }
    }
  },
  buildJsonServerQuery: function buildJsonServerQuery(searchVm) {
    var filterQuery = "";
    if (searchVm && searchVm.filters) {
      searchVm.filters.forEach(function (f) {
        filterQuery += f.property;
        filterQuery += f.op;
        filterQuery += "=";
        filterQuery += f.val;
        filterQuery += "&";
      });
    }
    return filterQuery;
  },
  getRootComponent: function getRootComponent(vueComponent) {
    var root = null;
    if (vueComponent && vueComponent._isVue) {
      if (vueComponent.isRootComponent) {
        return vueComponent;
      } else if (vueComponent.$parent) {
        return this.getRootComponent(vueComponent.$parent);
      } else {
        return root;
      }
    } else {
      return root;
    }
  }
});

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(353)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(397),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Doughnut"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
      datasets: [{
        backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
        data: [40, 20, 80, 10]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
}));

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_backend_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_app_util__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_progressbar__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_progressbar__);











var options = {
  color: '#2196f3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.1s',
    opacity: '0.5s',
    termination: 400
  },
  autoRevert: true,
  location: 'top',
  inverse: false
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_progressbar___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

window.Store = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.api = __WEBPACK_IMPORTED_MODULE_5__utils_backend_api__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.appUtil = __WEBPACK_IMPORTED_MODULE_6__utils_app_util__["a" /* default */];

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_backend_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_store_util_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_auth__ = __webpack_require__(31);










var state = {
  items: [],
  pagination: {},

  loading: false,
  mode: "",
  snackbar: false,
  notice: "",
  order: ""
};

var getters = {};

var actions = {
  getAllOrders: function getAllOrders(_ref) {
    var commit = _ref.commit;

    commit("setLoading", { loading: true });
    __WEBPACK_IMPORTED_MODULE_2__utils_backend_api__["a" /* default */].getData("OrderHistory.php?format=web").then(function (res) {
      var orders = res.data;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_store_util_js__["a" /* commitPagination */])(commit, orders);
      commit("setLoading", { loading: false });
    }).catch(function (err) {
      console.log(err);
      Store.dispatch('user/logout');
      location.reload();
    });
  },
  searchOrders: function searchOrders(_ref2, data, pagination) {
    var commit = _ref2.commit;

    var searchQuery = data.searchQuery;
    var postData = data.postData.replace("\n", ",");
    searchQuery = searchQuery.replace("New", "1");
    searchQuery = searchQuery.replace("In Process", "2");
    searchQuery = searchQuery.replace("Rejected", "3");
    searchQuery = searchQuery.replace("Replied", "4");

    var imeis = { "imeilist": postData };

    __WEBPACK_IMPORTED_MODULE_2__utils_backend_api__["a" /* default */].postData("OrderHistory.php?format=web&" + searchQuery, imeis).then(function (res) {
      var orders = res.data;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_store_util_js__["a" /* commitPagination */])(commit, orders);
    });
  },
  closeSnackBar: function closeSnackBar(_ref3, timeout) {
    var commit = _ref3.commit;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_store_util_js__["b" /* closeNotice */])(commit, timeout);
  }
};

var mutations = {
  setCustomers: function setCustomers(state, customers) {
    state.customers = customers;
  },
  setCategories: function setCategories(state, categories) {
    state.categories = categories;
  },
  setProducts: function setProducts(state, products) {
    state.products = products;
  },
  setOrderProducts: function setOrderProducts(state, products) {

    state.order.products = products;
  },
  setItems: function setItems(state, orders) {
    state.items = orders;
  },
  setPagination: function setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setLoading: function setLoading(state, _ref4) {
    var loading = _ref4.loading;

    state.loading = loading;
  },
  setNotice: function setNotice(state, _ref5) {
    var notice = _ref5.notice;

    state.notice = notice;
  },
  setSnackbar: function setSnackbar(state, _ref6) {
    var snackbar = _ref6.snackbar;

    state.snackbar = snackbar;
  },
  setMode: function setMode(state, _ref7) {
    var mode = _ref7.mode;

    state.mode = mode;
  },
  setOrder: function setOrder(state, _ref8) {
    var order = _ref8.order;

    state.order = order;
  },
  setLastOrder: function setLastOrder(state, _ref9) {
    var order = _ref9.order;

    state.lastcreatedorder = order;
  },
  setComments: function setComments(state, _ref10) {
    var comments = _ref10.comments;

    state.comments = comments;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {

  callingAPI: false,
  searching: "",
  user: null,
  token: null,
  userInfo: {
    messages: [],
    notifications: [],
    tasks: []
  }
};

var actions = {
  updateToken: function updateToken(_ref, _ref2) {
    var commit = _ref.commit;
    var token = _ref2.token;

    commit("setToken", token);
  },
  updateUser: function updateUser(_ref3, _ref4) {
    var commit = _ref3.commit;
    var user = _ref4.user,
        token = _ref4.token;

    commit("setToken", token);
    commit("setUser", user);
  },
  logout: function logout(_ref5) {
    var commit = _ref5.commit;

    commit("setToken", null);
    commit("setUser", {});
  }
};

var mutations = {
  loginLoading: function loginLoading(state) {
    state.callingAPI = !state.callingAPI;
  },
  globalSearching: function globalSearching(state) {
    state.searching = state.searching === "" ? "loading" : "";
  },
  setUser: function setUser(state, user) {
    state.user = user;
  },
  setToken: function setToken(state, token) {
    localStorage.token = token;
    state.token = token;
  },
  setUserInfo: function setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_ROW_PER_PAGE */
/* unused harmony export getDefaultPagination */
/* unused harmony export sendSuccessNotice */
/* unused harmony export sendErrorNotice */
/* unused harmony export setPagination */
/* harmony export (immutable) */ __webpack_exports__["b"] = closeNotice;
/* harmony export (immutable) */ __webpack_exports__["a"] = commitPagination;
var DEFAULT_ROW_PER_PAGE = 500;

function getDefaultPagination() {
  return {
    page: 1,
    totalItems: 0,
    rowsPerPage: DEFAULT_ROW_PER_PAGE,
    pages: 0
  };
}

function sendSuccessNotice(commit, notice) {
  commit("setNotice", {
    notice: notice
  });
  commit("setSnackbar", {
    snackbar: true
  });
  commit("setMode", {
    mode: "success"
  });
}

function sendErrorNotice(commit, notice) {
  commit("setNotice", {
    notice: notice
  });
  commit("setSnackbar", {
    snackbar: true
  });
  commit("setMode", {
    mode: "error"
  });
}

function setPagination(commit, page, totalItems, pages, rowsPerPage) {
  commit("setPagination", {
    page: page,
    totalItems: totalItems,
    pages: pages,
    rowsPerPage: rowsPerPage || DEFAULT_ROW_PER_PAGE
  });
}

function closeNotice(commit, timeout) {
  setTimeout(function () {
    commit("setSnackbar", {
      snackbar: false
    });
    commit("setNotice", {
      notice: ""
    });
    commit("setMode", {
      mode: ""
    });
  }, timeout);
}

function commitPagination(commit, items) {
  var totalItems = items ? items.length : 0;
  var pages = Math.ceil(totalItems / DEFAULT_ROW_PER_PAGE);

  commit("setItems", items);
  commit("setPagination", { totalItems: totalItems, pages: pages, page: 1, rowsPerPage: DEFAULT_ROW_PER_PAGE });
}

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      type: String,
      default: "xls"
    },

    data: {
      type: Array,
      required: false,
      default: null
    },

    fields: {
      type: Object,
      required: false
    },

    exportFields: {
      type: Object,
      required: false
    },

    defaultValue: {
      type: String,
      required: false,
      default: ""
    },

    title: {
      default: null
    },

    footer: {
      default: null
    },

    name: {
      type: String,
      default: "data.xls"
    },
    fetch: {
      type: Function
    },
    meta: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    worksheet: {
      type: String,
      default: "Sheet1"
    },

    beforeGenerate: {
      type: Function
    },

    beforeFinish: {
      type: Function
    }
  },
  computed: {
    idName: function idName() {
      var now = new Date().getTime();
      return "export_" + now;
    },
    downloadFields: function downloadFields() {
      if (this.fields !== undefined) return this.fields;

      if (this.exportFields !== undefined) return this.exportFields;
    }
  },
  methods: {
    generate: function generate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, json;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof _this.beforeGenerate === 'function')) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this.beforeGenerate();

              case 3:
                data = _this.data;

                if (!(typeof _this.fetch === 'function' || !data)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return _this.fetch();

              case 7:
                data = _context.sent;

              case 8:
                if (!(!data || !data.length)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                json = _this.getProcessedJson(data, _this.downloadFields);

                if (!(_this.type === "html")) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name.replace(".xls", ".html"), "text/html"));

              case 15:
                if (!(_this.type === "csv")) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToCSV(json), _this.name.replace(".xls", ".csv"), "application/csv"));

              case 17:
                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name, "application/vnd.ms-excel"));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    export: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(data, filename, mime) {
        var blob;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                blob = this.base64ToBlob(data, mime);

                if (!(typeof this.beforeFinish === 'function')) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.beforeFinish();

              case 4:
                __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(blob, filename, mime);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _export(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return _export;
    }(),
    jsonToXLS: function jsonToXLS(data) {
      var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>br {mso-data-placement: same-cell;}</style></head><body><table>${table}</table></body></html>';
      var xlsData = "<thead>";
      var colspan = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data[0]).length;
      var _self = this;

      if (this.title != null) {
        xlsData += this.parseExtraData(this.title, '<tr><th colspan="' + colspan + '">${data}</th></tr>');
      }

      xlsData += "<tr>";
      for (var key in data[0]) {
        xlsData += "<th>" + key + "</th>";
      }
      xlsData += "</tr>";
      xlsData += "</thead>";

      xlsData += "<tbody>";
      data.map(function (item, index) {
        xlsData += "<tr>";
        for (var _key in item) {
          xlsData += "<td>" + _self.valueReformattedForMultilines(item[_key]) + "</td>";
        }
        xlsData += "</tr>";
      });
      xlsData += "</tbody>";

      if (this.footer != null) {
        xlsData += "<tfoot>";
        xlsData += this.parseExtraData(this.footer, '<tr><td colspan="' + colspan + '">${data}</td></tr>');
        xlsData += "</tfoot>";
      }

      return xlsTemp.replace("${table}", xlsData).replace("${worksheet}", this.worksheet);
    },
    jsonToCSV: function jsonToCSV(data) {
      var csvData = [];

      if (this.title != null) {
        csvData.push(this.parseExtraData(this.title, "${data}\r\n"));
      }

      for (var key in data[0]) {
        csvData.push(key);
        csvData.push(",");
      }
      csvData.pop();
      csvData.push("\r\n");

      data.map(function (item) {
        for (var _key2 in item) {
          var escapedCSV = '=\"' + item[_key2] + '\"';
          if (escapedCSV.match(/[,"\n]/)) {
            escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
          }
          csvData.push(escapedCSV);
          csvData.push(",");
        }
        csvData.pop();
        csvData.push("\r\n");
      });

      if (this.footer != null) {
        csvData.push(this.parseExtraData(this.footer, "${data}\r\n"));
      }
      return csvData.join("");
    },
    getProcessedJson: function getProcessedJson(data, header) {
      var keys = this.getKeys(data, header);
      var newData = [];
      var _self = this;
      data.map(function (item, index) {
        var newItem = {};
        for (var label in keys) {
          var property = keys[label];
          newItem[label] = _self.getValue(property, item);
        }
        newData.push(newItem);
      });

      return newData;
    },
    getKeys: function getKeys(data, header) {
      if (header) {
        return header;
      }

      var keys = {};
      for (var key in data[0]) {
        keys[key] = key;
      }
      return keys;
    },
    parseExtraData: function parseExtraData(extraData, format) {
      var parseData = "";
      if (Array.isArray(extraData)) {
        for (var i = 0; i < extraData.length; i++) {
          parseData += format.replace("${data}", extraData[i]);
        }
      } else {
        parseData += format.replace("${data}", extraData);
      }
      return parseData;
    },
    getValue: function getValue(key, item) {
      var field = (typeof key === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(key)) !== "object" ? key : key.field;
      var indexes = typeof field !== "string" ? [] : field.split(".");
      var value = this.defaultValue;

      if (!field) value = item;else if (indexes.length > 1) value = this.getValueFromNestedItem(item, indexes);else value = this.parseValue(item[field]);

      if (key.hasOwnProperty('callback')) value = this.getValueFromCallback(value, key.callback);

      return value;
    },
    valueReformattedForMultilines: function valueReformattedForMultilines(value) {
      if (typeof value == "string") return value.replace(/\n/ig, "<br/>");else return value;
    },
    getValueFromNestedItem: function getValueFromNestedItem(item, indexes) {
      var nestedItem = item;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(indexes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var index = _step.value;

          if (nestedItem) nestedItem = nestedItem[index];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.parseValue(nestedItem);
    },
    getValueFromCallback: function getValueFromCallback(item, callback) {
      if (typeof callback !== "function") return this.defaultValue;
      var value = callback(item);
      return this.parseValue(value);
    },
    parseValue: function parseValue(value) {
      return value || value === 0 || typeof value === 'boolean' ? value : this.defaultValue;
    },
    base64ToBlob: function base64ToBlob(data, mime) {
      var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      var bstr = atob(base64);
      var n = bstr.length;
      var u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }
  } });

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pagetitle: '',
      dialog: false,
      mini: false,
      dialogText: "",
      dialogTitle: "",
      loggedIn: __WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* default */].loggedIn(),
      isRootComponent: true,
      drawer: true,
      fixed: false,
      enitems: [{
        icon: "dashboard",
        title: "Dashboard",
        vertical: "Dashboard",
        link: "dashboard"
      }, {
        icon: "layers",
        title: "PlaceOrder",
        vertical: "PlaceOrder",
        link: "neworder"
      }, {
        icon: "subject",
        title: "OrderHistory",
        vertical: "OrderHistory",
        link: "history"
      }, {
        icon: "description",
        title: "Parser",
        vertical: "Parser",
        link: "parser"
      }, {
        icon: "link",
        title: "API",
        vertical: "API",
        link: "apisetup"
      }, {
        icon: "attach_money",
        title: "AddCredits",
        vertical: "AddCredits",
        link: "credits"
      }],
      cnitems: [{
        icon: "dashboard",
        title: "aaaaa",
        vertical: "aaaa",
        component: "Dashboard",
        link: "dashboard"
      }, {
        icon: "layers",
        title: "PlaceOrder",
        vertical: "PlaceOrder",
        link: "neworder"
      }, {
        icon: "subject",
        title: "OrderHistory",
        vertical: "OrderHistory",
        link: "history"
      }, {
        icon: "description",
        title: "Parser",
        vertical: "Parser",
        link: "parser"
      }, {
        icon: "link",
        title: "API",
        vertical: "API",
        link: "apisetup"
      }, {
        icon: "attach_money",
        title: "AddCredits",
        vertical: "AddCredits",
        link: "credits"
      }],
      userMenus: [{
        icon: "bubble_chart",
        title: "Logout",
        link: "/logout"
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      menuItem: "Orders"
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* default */].onChange = function (loggedIn) {
      _this.loggedIn = loggedIn;
    };

    this.$Progress.start();

    this.$router.beforeEach(function (to, from, next) {
      if (to.meta.progress !== undefined) {
        var meta = to.meta.progress;

        _this.$Progress.parseMeta(meta);
      }

      _this.$Progress.start();

      next();
    });

    this.$router.afterEach(function (to, from) {
      if (to.name !== "ErrorPage") {
        _this.menuItem = to.name;
      }

      _this.$Progress.finish();
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])("user", {
    user: "user"
  }), {
    auth: function auth() {
      return __WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* default */];
    },
    activeMenuItem: function activeMenuItem() {
      return this.menuItem;
    },

    items: function items() {
      if (window.location.hostname.includes("local")) {
        return this.cnitems;
      } else {
        return this.enitems;
      }
    }
  }),
  methods: {
    clickMenu: function clickMenu(item) {
      this.menuItem = item.title;
      this.$router.push({
        name: item.title
      });
    }
  },
  mounted: function mounted() {
    this.$Progress.finish();
    this.pagetitle = window.location.hostname;
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ErrorPage',
  data: function data() {
    return {
      msg: 'Sorry, the page you\'re looking for doesn\'t exist.'
    };
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    dialogText: '',
    dialogTitle: '',
    dialog: '',
    listName: ''
  },
  data: function data() {
    return {
      mini: false,
      isRootComponent: true,

      drawer: true,
      fixed: false
    };
  },

  methods: {
    onConfirm: function onConfirm() {},
    onCancel: function onCancel() {}
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__(31);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pagetitle: '',
      key: '',
      error: false,
      text: '',
      isH: false
    };
  },
  mounted: function mounted() {
    this.pagetitle = window.location.hostname;
    if (this.pagetitle.includes("mate")) {
      this.isH = true;
    }
    if (localStorage.userkey.length > 5) {
      this.key = localStorage.userkey;
      this.login();
    }
  },

  methods: {
    login: function login() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_auth__["a" /* default */].login(this.key, function (loggedIn, err) {
        if (err) {
          if (localStorage.userkey === _this.key) {
            localStorage.userkey = null;
          }
          _this.error = true;
          _this.text = err.response.data;
        } else if (loggedIn === false) {
          if (localStorage.userkey === _this.key) {
            localStorage.userkey = null;
          }
          _this.error = true;
          _this.text = 'Bad login information';
        } else {
          localStorage.userkey = _this.key;
          _this.$router.push(_this.$route.query.redirect || '/');
        }
      });
    }
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-panel',
  props: {
    rightDrawer: ''
  },
  data: function data() {
    return {
      right: true
    };
  },

  methods: {
    cancelSearch: function cancelSearch() {}
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-panel',
  props: {
    rightDrawer: ''
  },
  data: function data() {
    return {
      right: true,
      searchVm: {
        contains: {
          productName: '',
          category: ''
        },
        between: {
          price: {
            former: 0,
            latter: 0
          }
        }
      }
    };
  },

  methods: {
    cancelSearch: function cancelSearch() {},
    searchData: function searchData() {}
  },

  created: function created() {},
  mounted: function mounted() {
    this.$nextTick(function () {});
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    headers: '',
    items: '',
    pagination: ''
  },
  data: function data() {
    return {
      search: ""
    };
  },

  methods: {
    renderData: function renderData(item, header) {
      var val = "";
      if (header.value.includes('.')) {
        var vals = header.value.split('.');
        val = vals.reduce(function (acc, val) {
          return acc[val];
        }, item);
      } else {
        val = item[header.value];
      }
      if (typeof val === "boolean") {
        val = val ? "Yes" : "No";
      }
      return val;
    }
  },
  computed: {
    isNotEmpty: function isNotEmpty() {
      return this.items && this.items.length > 0;
    }
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backend_api__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      apikey: '',
      apiip: '',
      editableip: true
    };
  },

  methods: {
    changeip: function changeip() {
      if (this.$refs.changeipbutt.text === "Change IP") {
        this.editableip = false;
        this.apiip = '';
        this.$refs.ipbox.focus();
        this.$refs.changeipbutt.text = "Update IP";
      } else {
        this.$refs.changeipbutt.text = "Change IP";
        this.editableip = true;
        this.updateIp();
      }
    },
    resetip: function resetip() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_backend_api__["a" /* default */].getData("apidetails.php?action=resetip").then(function (res) {
        if (res.data) {
          _this.apikey = res.data.api.key;
          if (res.data.api.ip === "") {
            _this.apiip = "API Disabled";
          } else {
            _this.apiip = res.data.api.ip;
          }
        }
      });
    },
    disableapi: function disableapi() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_backend_api__["a" /* default */].getData("apidetails.php?action=ip&newip=").then(function (res) {
        if (res.data) {
          _this2.apikey = res.data.api.key;
          if (res.data.api.ip === "") {
            _this2.apiip = "API Disabled";
          } else {
            _this2.apiip = res.data.api.ip;
          }
        }
      });
    },
    updateKey: function updateKey() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_backend_api__["a" /* default */].getData("apidetails.php?action=update").then(function (res) {
        if (res.data) {
          _this3.apikey = res.data.api.key;
          if (res.data.api.ip === "") {
            _this3.apiip = "API Disabled";
          } else {
            _this3.apiip = res.data.api.ip;
          }
        }
      });
    },
    updateIp: function updateIp() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_backend_api__["a" /* default */].getData("apidetails.php?action=ip&newip=" + this.apiip).then(function (res) {
        if (res.data) {
          _this4.apikey = res.data.api.key;
          if (res.data.api.ip === "") {
            _this4.apiip = "API Disabled";
          } else {
            _this4.apiip = res.data.api.ip;
          }
        }
      });
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_0__utils_backend_api__["a" /* default */].getData("apidetails.php").then(function (res) {
      if (res.data) {
        _this5.apikey = res.data.api.key;
        if (res.data.api.ip === "") {
          _this5.apiip = "API Disabled";
        } else {
          _this5.apiip = res.data.api.ip;
        }
      }
    });
  }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConfirmDialog_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConfirmDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConfirmDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_backend_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(59);







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ConfirmDialog: __WEBPACK_IMPORTED_MODULE_0__components_ConfirmDialog_vue___default.a
  },
  data: function data() {
    return {
      txnid: "",
      serverResponse: "",
      showSubmitButton: false,
      allowed: false
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__utils_backend_api__["a" /* default */].getData("processPaypal.php?action=check").then(function (res) {
      if (res.data === "oK") {
        _this.allowed = true;
      }
    });
  },

  methods: {
    submitPayment: function submitPayment() {
      var _this2 = this;

      this.serverResponse = "";
      __WEBPACK_IMPORTED_MODULE_2__utils_backend_api__["a" /* default */].postData("processPaypal.php", "txnid=" + this.txnid).then(function (res) {
        _this2.serverResponse = res.data;
        _this2.txnid = "";
        _this2.showSubmitButton = false;
        _this2.updateCredits();
      }, function (err) {
        if (err.message.includes("403")) {
          _this2.$router.push('/login');
        } else {
          alert(err.response.data);
        }
      });
    },
    txnidLength: function txnidLength() {
      if (this.txnid.length > 15) {
        this.showSubmitButton = true;
      } else {
        this.showSubmitButton = false;
      }
    },
    updateCredits: function updateCredits() {
      __WEBPACK_IMPORTED_MODULE_2__utils_backend_api__["a" /* default */].getData("userinfo.php").then(function (res) {
        if (res.data) {
          var user = res.data.user;
          var token = localStorage.token;
          Store.dispatch('user/updateUser', { user: user, token: token });
        }
      });
    }
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chart_Doughnut__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_backend_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(61);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Dashboard",
  data: function data() {
    return {
      orders: [],
      credits: ''
    };
  },

  methods: {},
  components: {
    Doughnut: __WEBPACK_IMPORTED_MODULE_0__components_chart_Doughnut__["a" /* default */]
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_backend_api__["a" /* default */].getData("statistics.php").then(function (res) {
      _this.orders = res.data.orders;
      _this.credits = res.data.user.credit;
      var user = res.data.user;
      var token = localStorage.token;
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('user/updateUser', { user: user, token: token });
    }, function (err) {
      console.log(err);
      if (err.message.includes("403")) {
        _this.$router.push('/login');
      }
    });
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Table_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SearchPanel_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SearchPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SearchPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_backend_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Table: __WEBPACK_IMPORTED_MODULE_1__components_Table_vue___default.a,
    SearchPanel: __WEBPACK_IMPORTED_MODULE_2__components_SearchPanel_vue___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      statuss: ['New', 'In Process', 'Rejected', 'Replied'],
      dialog: false,
      dialogTitle: "Order Delete Dialog",
      dialogText: "Do you want to delete this order?",
      rightDrawer: false,
      right: true,
      search: '',
      techs: [],
      headers: [{ "text": "#", "value": "id", "left": true }, { "text": "IMEI", "value": "imei" }, { "text": "Reply", "value": "reply" }, { "text": "Status", "value": "status" }],
      searchVm: {
        contains: {
          jobid: ''
        },
        equals: {
          listid: '',
          imeilist: "",
          start: new Date(),
          end: new Date(),
          status: ''
        }
      },
      searchimeis: "",
      orderId: "",
      query: "",
      snackbarStatus: false,
      timeout: 2000,
      color: "",
      quickSearchFilter: ""
    };
  },

  methods: {
    customFormatter: function customFormatter(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format('YYYY-MM-DD');
    },
    searchOrders: function searchOrders() {
      this.rightDrawer = !this.rightDrawer;
      this.searchVm.equals.start = this.customFormatter(this.searchVm.equals.start);
      this.searchVm.equals.end = this.customFormatter(this.searchVm.equals.end);
      this.searchimeis = this.searchVm.equals.imeilist;
      this.searchVm.equals.imeilist = "";
      this.appUtil.buildSearchFilters(this.searchVm);
      this.query = this.appUtil.buildJsonServerQuery(this.searchVm);

      var searcher = { "searchQuery": this.query, "postData": this.searchimeis };

      Store.dispatch("orders/searchOrders", searcher, this.pagination);
    },
    reloadData: function reloadData() {
      this.query = "";
      Store.dispatch("orders/getAllOrders");
    },
    cancelSearch: function cancelSearch() {
      this.rightDrawer = false;
    },
    closeSnackbar: function closeSnackbar() {
      Store.commit("orders/setSnackbar", { snackbar: false });
      Store.commit("orders/setNotice", { notice: "" });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])("orders", {
    items: "items",
    pagination: "pagination",
    loading: "loading",
    mode: "mode",
    snackbar: "snackbar",
    notice: "notice"
  })),
  created: function created() {
    Store.dispatch("orders/getAllOrders");
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Table_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SearchPanel_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SearchPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SearchPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ConfirmDialog_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ConfirmDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ConfirmDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_backend_api__ = __webpack_require__(10);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Table: __WEBPACK_IMPORTED_MODULE_1__components_Table_vue___default.a,
    SearchPanel: __WEBPACK_IMPORTED_MODULE_2__components_SearchPanel_vue___default.a,
    ConfirmDialog: __WEBPACK_IMPORTED_MODULE_3__components_ConfirmDialog_vue___default.a
  },
  data: function data() {
    return {
      statuss: ['Open', 'In Process', 'Closed', 'Rejected'],
      dialog: false,
      dialogTitle: "Order Delete Dialog",
      dialogText: "Do you want to delete this order?",
      rightDrawer: false,
      right: true,
      search: '',
      techs: [],
      headers: [{
        text: 'ID',
        left: true,
        value: 'id'
      }, { text: 'Make', value: 'make' }, { text: 'Model', value: 'model' }, { text: 'Serial', value: 'deviceid' }, { text: 'Technician', value: 'techid' }, { text: 'Customer', value: 'custid' }, { text: 'Description', value: 'description' }, { text: 'Status', value: 'status' }, { text: 'Created', value: 'createdon' }, { text: 'Updated', value: 'lastupdated' }],
      searchVm: {
        contains: {
          jobid: '',
          reference: ''
        },
        equals: {
          jobid: '',
          custphone: '',
          deviceid: '',
          status: '',
          techid: ''
        }

      },
      orderId: "",
      query: "",
      snackbarStatus: false,
      timeout: 2000,
      color: "",
      quickSearchFilter: ""
    };
  },

  methods: {
    getTechs: function getTechs() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__utils_backend_api__["a" /* default */].getData("getTechs.php").then(function (res) {
        _this.techs = res.data;
      }, function (err) {
        console.log(err);
      });
    },
    print: function print() {
      window.print();
    },
    edit: function edit(item) {
      this.$router.push({ name: 'OrderDetails', params: { id: item.id } });
    },
    add: function add() {
      this.$router.push('NewOrder');
    },
    searchOrders: function searchOrders() {
      this.rightDrawer = !this.rightDrawer;
      this.appUtil.buildSearchFilters(this.searchVm);
      this.query = this.appUtil.buildJsonServerQuery(this.searchVm);
      Store.dispatch("orders/searchOrders", this.query, this.pagination);
    },
    reloadData: function reloadData() {
      this.query = "";
      Store.dispatch("orders/getAllOrders");
    },
    cancelSearch: function cancelSearch() {
      this.rightDrawer = false;
    },
    closeSnackbar: function closeSnackbar() {
      Store.commit("orders/setSnackbar", { snackbar: false });
      Store.commit("orders/setNotice", { notice: "" });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])("orders", {
    items: "items",
    pagination: "pagination",
    loading: "loading",
    mode: "mode",
    snackbar: "snackbar",
    notice: "notice"
  })),
  created: function created() {
    Store.dispatch("orders/getAllOrders");
    this.getTechs();
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_backend_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_json_excel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_custom_scrollbar__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_custom_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_custom_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ParsePanel_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ParsePanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ParsePanel_vue__);









__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('downloadExcel', __WEBPACK_IMPORTED_MODULE_4_vue_json_excel___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  watch: {
    headers: function headers() {
      if (this.headers !== null) {
        this.excelHeaders = {};
        for (var i = 0; i < this.headers.length; ++i) {
          this.excelHeaders[this.headers[i]] = this.headers[i];
        }
      }
    }
  },
  components: {
    vueCustomScrollbar: __WEBPACK_IMPORTED_MODULE_5_vue_custom_scrollbar___default.a,
    ParserPanel: __WEBPACK_IMPORTED_MODULE_6__components_ParsePanel_vue___default.a
  },
  data: function data() {
    return {
      lists: "",
      headers: [],
      fullheaders: [],
      items: [],
      sort: '',
      sortDir: 'asc',
      loading: false,
      rightDrawer: false,
      excelHeaders: {}
    };
  },

  computed: {
    sortedItems: function sortedItems() {
      var _this = this;

      if (this.sort !== '') {
        return this.items.sort(function (a, b) {
          var dir = _this.sortDir === 'asc' ? 1 : -1;
          if (a[_this.sort] < b[_this.sort]) {
            return -1 * dir;
          } else if (a[_this.sort] > b[_this.sort]) {
            return 1 * dir;
          } else {
            return 0;
          }
        });
      } else {
        return this.items;
      }
    }

  },

  methods: {
    sortBy: function sortBy(s) {
      if (s === this.sort) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortDir = 'asc';
      }
      this.sort = s;
    },
    isActiveSort: function isActiveSort(s) {
      return this.sort === s;
    },
    fetchOrders: function fetchOrders() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_backend_api__["a" /* default */].getData("fetchOrders.php?lists=" + this.lists).then(function (res) {
        _this2.headers = res.data.shift();
        _this2.fullheaders = _this2.headers;
        _this2.items = res.data;
      }).catch(function (err) {
        console.log(err);
        Store.dispatch('user/logout');
        location.reload();
      });
    },

    renderData: function renderData(item, header) {
      var val = "";
      if (header.includes('.')) {
        var vals = header.split('.');
        val = vals.reduce(function (acc, val) {
          return acc[val];
        }, item);
      } else {
        console.log(item);
        val = item[header];
      }
      if (typeof val === "boolean") {
        val = val ? "Yes" : "No";
      }
      return val;
    },
    getFileName: function getFileName() {
      var d = new Date();

      return window.location.hostname + " - " + this.lists + ".xls";
    },
    closeSnackbar: function closeSnackbar() {
      Store.commit("orders/setSnackbar", { snackbar: false });
      Store.commit("orders/setNotice", { notice: "" });
    },
    cancelSearch: function cancelSearch() {
      this.rightDrawer = false;
    }
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ConfirmDialog_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ConfirmDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ConfirmDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_backend_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_multipane_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_multipane_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_multipane_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_multipane_resizer_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_multipane_resizer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_multipane_resizer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_overflow_scroll__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_overflow_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_overflow_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_toggle_button__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_js_toggle_button__);














__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_js_toggle_button___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_overflow_scroll___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  watch: {
    instantcheck: function instantcheck() {
      if (this.instantcheck) {
        document.title = this.chosenservice.name;
        this.msgList = [];
      } else {
        document.title = window.location.hostname;
        if (localStorage.getItem("listshistory") === null) {
          this.msgList = [];
        } else {
          this.msgList = JSON.parse(localStorage.getItem("listshistory"));
        }
      }
    },
    chosenservice: function chosenservice() {
      if (this.instantcheck) {
        document.title = this.chosenservice.name;
      } else {
        document.title = window.location.hostname;
      }
    },
    qtydone: function qtydone() {
      if (this.qtydone === this.totalsubmitted) {
        this.DisableCheckComponents = false;
      } else {
        this.DisableCheckComponents = true;
      }
    }
  },
  components: {
    ConfirmDialog: __WEBPACK_IMPORTED_MODULE_3__components_ConfirmDialog_vue___default.a,
    Multipane: __WEBPACK_IMPORTED_MODULE_6__components_multipane_vue___default.a,
    MultipaneResizer: __WEBPACK_IMPORTED_MODULE_7__components_multipane_resizer_vue___default.a
  },
  data: function data() {
    return {
      categoryId: null,
      showDialog: false,
      dialogTitle: "",
      dialogText: "",
      orderDateMenu: false,
      shippedDateMenu: false,
      errors: [],
      title: '',
      snackbarStatus: false,
      timeout: 3000,
      color: '',
      services: [],
      chosenserviceid: "",
      chosenservice: [],
      msgList: [],
      imeilist: "",
      showIMEIBox: false,
      showOrderButton: false,
      showCheckButton: false,
      DisableCheckComponents: false,
      isPhoneView: false,
      pendingOrders: [],
      qtydone: 0,
      totalsubmitted: 0,
      nonce: 0,
      creditsUpdated: false,
      instantcheck: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('orders', {
    order: 'order',
    lastcreatedorder: 'lastcreatedorder',
    categories: 'categories',
    products: 'products',
    loading: 'loading',
    mode: 'mode',
    snackbar: 'snackbar',
    notice: 'notice'
  })),
  methods: {
    leaving: function leaving() {
      alert("Leaving...");
    },
    clearLog: function clearLog() {
      this.msgList = [];
      localStorage.setItem("listshistory", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.msgList));
    },
    updateCredits: function updateCredits() {
      __WEBPACK_IMPORTED_MODULE_5__utils_backend_api__["a" /* default */].getData("userinfo.php").then(function (res) {
        if (res.data) {
          var user = res.data.user;
          var token = localStorage.token;
          Store.dispatch('user/updateUser', { user: user, token: token });
        }
      });
    },
    ordersFetcher: function ordersFetcher(vue) {
      var x = setInterval(function () {
        var _this = this;

        if (vue.qtydone !== vue.totalsubmitted) {
          __WEBPACK_IMPORTED_MODULE_5__utils_backend_api__["a" /* default */].postData("fetchOrders.php?format=web&nonce=" + vue.nonce, { "orderslist": vue.pendingOrders.toString() }).then(function (res) {
            var repliesArray = res.data;
            var arrayLength = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(repliesArray).length;
            for (var i = 1; i < arrayLength; i++) {
              var r = repliesArray[i]["reply"].replace(new RegExp("<br>", "g"), '\n');
              if (r.length > 1) {
                vue.qtydone++;
                vue.$set(vue.msgList, repliesArray[i]["id"], r);
                for (var x = vue.pendingOrders.length + 1; x >= 0; x--) {
                  if (vue.pendingOrders[x] === parseInt(repliesArray[i]["id"]) + vue.nonce + "") {
                    vue.pendingOrders.splice(x, 1);
                  }
                }
              }
            }
          }, function (err) {
            alert("Error Fetching Orders");
            if (err.message.includes("403")) {
              _this.$router.push('/login');
            }
          });
        } else {

          if (vue.creditsUpdated === false) {
            vue.updateCredits();
            vue.creditsUpdated = true;
          }
        }
      }, 10000);
    },
    countIMEIs: function countIMEIs() {
      return this.imeilist.length ? this.imeilist.split(/\r\n|\r|\n/).length : 0;
    },
    checkIMEI: function checkIMEI(imei, link) {
      var _this2 = this;

      var x = link.replace("[imei]", imei);
      __WEBPACK_IMPORTED_MODULE_5__utils_backend_api__["a" /* default */].getDataByURL(x).then(function (res) {
        _this2.msgList.unshift(res.data);
      }, function (err) {
        console.log(err);
      });
    },
    getServices: function getServices() {
      var _this3 = this;

      var link = "getServices.php";
      if (window.location.hostname.includes("7")) {
        link = link + "?lang=cn";
      }
      __WEBPACK_IMPORTED_MODULE_5__utils_backend_api__["a" /* default */].getData(link).then(function (res) {
        _this3.services = res.data;
      }, function (err) {
        if (err.message.includes("403")) {
          _this3.$router.push('/login');
        }
      });
    },
    onSubmit: function onSubmit() {
      this.dialogTitle = this.chosenservice.displayname;
      this.dialogText = "Do you wish to submit " + this.countIMEIs() + " IMEI(s)?";
      this.showDialog = true;
    },
    onCheck: function onCheck() {
      this.DisableCheckComponents = true;
      var link = this.chosenservice.directlink;
      var imeisArray = this.imeilist.split("\n");
      for (var i = 0; i < imeisArray.length; i++) {
        this.checkIMEI(imeisArray[i], link);
      }
      this.DisableCheckComponents = false;
      this.imeilist = "";
    },
    onCancel: function onCancel() {
      this.showDialog = false;
    },
    getChosenServiceDetails: function getChosenServiceDetails() {
      for (var i = 0; i < this.services.length; i++) {
        if (this.services[i].id === this.chosenserviceid) {
          this.chosenservice = this.services[i];
          this.showIMEIBox = true;
          if (this.services[i].directlink.length !== 0) {
            this.showCheckButton = true;
          } else {
            this.showCheckButton = false;
          }
          if (this.services[i].ordersupport === "1") {
            this.showOrderButton = true;
          } else {
            this.showOrderButton = false;
          }
          return;
        }
      }
      this.showIMEIBox = false;
      return;
    },
    selectCustomer: function selectCustomer(item) {
      this.order.customerId = item.value;
    },
    getOrderById: function getOrderById() {
      Store.dispatch('orders/getOrderById', this.$route.params.id);
    },
    cancel: function cancel() {
      this.$router.push({ name: 'WorkJobs' });
    },
    remove: function remove(item) {
      this.selectedProduct = item;
      this.dialog = true;
    },
    onConfirm: function onConfirm() {
      var _this4 = this;

      var count = this.countIMEIs();
      this.showDialog = false;
      if (this.countIMEIs() === 0) {
        alert("Empty list");
        return;
      }
      this.DisableCheckComponents = true;

      var orderData = {
        comments: this.listName,
        imeilist: this.imeilist,
        serviceid: this.chosenserviceid
      };
      this.nonce = 0;
      this.qtydone = 0;
      this.totalsubmitted = 0;
      if (this.instantcheck) {
        this.msgList = [];
      }
      this.creditsUpdated = false;
      var x = "";
      if (!this.instantcheck) {
        x = "?type=list";
      }
      __WEBPACK_IMPORTED_MODULE_5__utils_backend_api__["a" /* default */].postData("submitOrder.php" + x, orderData).then(function (res) {
        if (res.data.includes("OK")) {
          res.data = res.data.replace("OK ", "");

          if (_this4.instantcheck) {
            _this4.pendingOrders = res.data.split(",");
            _this4.totalsubmitted = _this4.pendingOrders.length;
            _this4.nonce = _this4.pendingOrders[0] - 1;
            if (_this4.nonce === -1) {
              alert("Order Error");
              _this4.totalsubmitted = 0;
            }
          } else {
            if (localStorage.getItem("listshistory") !== null) {
              _this4.msgList = JSON.parse(localStorage.getItem("listshistory"));
              _this4.msgList.push(count + " IMEIs submitted on " + _this4.chosenservice.name + " with list #" + res.data);
              localStorage.setItem("listshistory", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this4.msgList));
            }
          }

          Store.commit("orders/setNotice", { notice: "Order successfully submitted!" });
        } else {
          alert("Error submitting order:" + res.data);
        }
      }, function (err) {
        alert("Error Submitting Order");
        if (err.message.includes("403")) {
          _this4.$router.push('/login');
        }
      });
      this.imeilist = "";
      if (!this.instantcheck) {
        this.DisableCheckComponents = false;
      }
    },
    saveProduct: function saveProduct() {
      Store.dispatch('orders/addProductToOrder', this.productId);
      this.productId = null;
      this.addProductModal = false;
    },
    cancelAddProduct: function cancelAddProduct() {
      this.addProductModal = false;
    },
    getCategories: function getCategories() {
      Store.dispatch('orders/getCategories');
    },
    getProductsByCategory: function getProductsByCategory() {
      this.categoryId && Store.dispatch('orders/getProductsByCategory', this.categoryId);
    },
    closeSnackbar: function closeSnackbar() {
      Store.commit("orders/setNotice", { notice: "" });
    }
  },
  created: function created() {
    if (screen.width <= 600) {
      this.isPhoneView = true;
    }

    if (localStorage.getItem("listshistory") === null) {
      this.msgList = [];
    } else {
      this.msgList = JSON.parse(localStorage.getItem("listshistory"));
    }
    this.getServices();
  },
  mounted: function mounted() {

    this.ordersFetcher(this);
  },
  ready: function ready() {
    window.addEventListener('beforeunload', this.leaving);
    window.addEventListener('onblur', this.leaving);
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var LAYOUT_HORIZONTAL = 'horizontal';
var LAYOUT_VERTICAL = 'vertical';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multipane',

  props: {
    layout: {
      type: String,
      default: LAYOUT_VERTICAL
    }
  },

  data: function data() {
    return {
      isResizing: false
    };
  },


  computed: {
    classnames: function classnames() {
      return ['multipane', 'layout-' + this.layout.slice(0, 1), this.isResizing ? 'is-resizing' : ''];
    },
    cursor: function cursor() {
      return this.isResizing ? this.layout == LAYOUT_VERTICAL ? 'col-resize' : 'row-resize' : '';
    },
    userSelect: function userSelect() {
      return this.isResizing ? 'none' : '';
    }
  },

  methods: {
    onMouseDown: function onMouseDown(_ref) {
      var resizer = _ref.target,
          initialPageX = _ref.pageX,
          initialPageY = _ref.pageY;

      if (resizer.className && resizer.className.match('multipane-resizer')) {
        var self = this;
        var container = self.$el,
            layout = self.layout;


        var pane = resizer.previousElementSibling;
        var initialPaneWidth = pane.offsetWidth,
            initialPaneHeight = pane.offsetHeight;


        var usePercentage = !!(pane.style.width + '').match('%');

        var _window = window,
            addEventListener = _window.addEventListener,
            removeEventListener = _window.removeEventListener;


        var resize = function resize(initialSize) {
          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

          if (layout == LAYOUT_VERTICAL) {
            var containerWidth = container.clientWidth;
            var paneWidth = initialSize + offset;

            return pane.style.width = usePercentage ? paneWidth / containerWidth * 100 + '%' : paneWidth + 'px';
          }

          if (layout == LAYOUT_HORIZONTAL) {
            var containerHeight = container.clientHeight;
            var paneHeight = initialSize + offset;

            return pane.style.height = usePercentage ? paneHeight / containerHeight * 100 + '%' : paneHeight + 'px';
          }
        };

        self.isResizing = true;

        var size = resize();

        self.$emit('paneResizeStart', pane, resizer, size);

        var onMouseMove = function onMouseMove(_ref2) {
          var pageX = _ref2.pageX,
              pageY = _ref2.pageY;

          size = layout == LAYOUT_VERTICAL ? resize(initialPaneWidth, pageX - initialPageX) : resize(initialPaneHeight, pageY - initialPageY);

          self.$emit('paneResize', pane, resizer, size);
        };

        var onMouseUp = function onMouseUp() {
          size = layout == LAYOUT_VERTICAL ? resize(pane.clientWidth) : resize(pane.clientHeight);

          self.isResizing = false;

          removeEventListener('mousemove', onMouseMove);
          removeEventListener('mouseup', onMouseUp);

          self.$emit('paneResizeStop', pane, resizer, size);
        };

        addEventListener('mousemove', onMouseMove);
        addEventListener('mouseup', onMouseUp);
      }
    }
  }
});

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend_api__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(key, cb) {
    var _this = this;

    cb = arguments[arguments.length - 1];
    var data = 'userkey=' + key;
    __WEBPACK_IMPORTED_MODULE_0__backend_api__["a" /* default */].login('login.php', data).then(function (res) {
      var token = res.access_token || res.data.access_token;
      var user = res.user || res.data.user;
      Store.dispatch('user/updateUser', { user: user, token: token });
      if (cb) cb(true, null);
      _this.onChange(true);
    }, function (err) {
      console.log(err);
      if (cb) cb(false, err);
      _this.onChange(false);
    });
  },
  getToken: function getToken() {
    return Store.state.user.token;
  },
  logout: function logout(cb) {
    var _this2 = this;

    localStorage.userkey = null;
    __WEBPACK_IMPORTED_MODULE_0__backend_api__["a" /* default */].logout().then(function (res) {
      Store.dispatch('user/logout');
    }, function (err) {
      if (cb) cb(false, err);
      _this2.onChange(false);
    });
  },
  loggedIn: function loggedIn() {
    return !!Store.state.user.token;
  },
  onChange: function onChange() {}
});

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 89,
	"./af.js": 89,
	"./ar": 96,
	"./ar-dz": 90,
	"./ar-dz.js": 90,
	"./ar-kw": 91,
	"./ar-kw.js": 91,
	"./ar-ly": 92,
	"./ar-ly.js": 92,
	"./ar-ma": 93,
	"./ar-ma.js": 93,
	"./ar-sa": 94,
	"./ar-sa.js": 94,
	"./ar-tn": 95,
	"./ar-tn.js": 95,
	"./ar.js": 96,
	"./az": 97,
	"./az.js": 97,
	"./be": 98,
	"./be.js": 98,
	"./bg": 99,
	"./bg.js": 99,
	"./bm": 100,
	"./bm.js": 100,
	"./bn": 101,
	"./bn.js": 101,
	"./bo": 102,
	"./bo.js": 102,
	"./br": 103,
	"./br.js": 103,
	"./bs": 104,
	"./bs.js": 104,
	"./ca": 105,
	"./ca.js": 105,
	"./cs": 106,
	"./cs.js": 106,
	"./cv": 107,
	"./cv.js": 107,
	"./cy": 108,
	"./cy.js": 108,
	"./da": 109,
	"./da.js": 109,
	"./de": 112,
	"./de-at": 110,
	"./de-at.js": 110,
	"./de-ch": 111,
	"./de-ch.js": 111,
	"./de.js": 112,
	"./dv": 113,
	"./dv.js": 113,
	"./el": 114,
	"./el.js": 114,
	"./en-au": 115,
	"./en-au.js": 115,
	"./en-ca": 116,
	"./en-ca.js": 116,
	"./en-gb": 117,
	"./en-gb.js": 117,
	"./en-ie": 118,
	"./en-ie.js": 118,
	"./en-il": 119,
	"./en-il.js": 119,
	"./en-nz": 120,
	"./en-nz.js": 120,
	"./eo": 121,
	"./eo.js": 121,
	"./es": 124,
	"./es-do": 122,
	"./es-do.js": 122,
	"./es-us": 123,
	"./es-us.js": 123,
	"./es.js": 124,
	"./et": 125,
	"./et.js": 125,
	"./eu": 126,
	"./eu.js": 126,
	"./fa": 127,
	"./fa.js": 127,
	"./fi": 128,
	"./fi.js": 128,
	"./fo": 129,
	"./fo.js": 129,
	"./fr": 132,
	"./fr-ca": 130,
	"./fr-ca.js": 130,
	"./fr-ch": 131,
	"./fr-ch.js": 131,
	"./fr.js": 132,
	"./fy": 133,
	"./fy.js": 133,
	"./gd": 134,
	"./gd.js": 134,
	"./gl": 135,
	"./gl.js": 135,
	"./gom-latn": 136,
	"./gom-latn.js": 136,
	"./gu": 137,
	"./gu.js": 137,
	"./he": 138,
	"./he.js": 138,
	"./hi": 139,
	"./hi.js": 139,
	"./hr": 140,
	"./hr.js": 140,
	"./hu": 141,
	"./hu.js": 141,
	"./hy-am": 142,
	"./hy-am.js": 142,
	"./id": 143,
	"./id.js": 143,
	"./is": 144,
	"./is.js": 144,
	"./it": 145,
	"./it.js": 145,
	"./ja": 146,
	"./ja.js": 146,
	"./jv": 147,
	"./jv.js": 147,
	"./ka": 148,
	"./ka.js": 148,
	"./kk": 149,
	"./kk.js": 149,
	"./km": 150,
	"./km.js": 150,
	"./kn": 151,
	"./kn.js": 151,
	"./ko": 152,
	"./ko.js": 152,
	"./ky": 153,
	"./ky.js": 153,
	"./lb": 154,
	"./lb.js": 154,
	"./lo": 155,
	"./lo.js": 155,
	"./lt": 156,
	"./lt.js": 156,
	"./lv": 157,
	"./lv.js": 157,
	"./me": 158,
	"./me.js": 158,
	"./mi": 159,
	"./mi.js": 159,
	"./mk": 160,
	"./mk.js": 160,
	"./ml": 161,
	"./ml.js": 161,
	"./mn": 162,
	"./mn.js": 162,
	"./mr": 163,
	"./mr.js": 163,
	"./ms": 165,
	"./ms-my": 164,
	"./ms-my.js": 164,
	"./ms.js": 165,
	"./mt": 166,
	"./mt.js": 166,
	"./my": 167,
	"./my.js": 167,
	"./nb": 168,
	"./nb.js": 168,
	"./ne": 169,
	"./ne.js": 169,
	"./nl": 171,
	"./nl-be": 170,
	"./nl-be.js": 170,
	"./nl.js": 171,
	"./nn": 172,
	"./nn.js": 172,
	"./pa-in": 173,
	"./pa-in.js": 173,
	"./pl": 174,
	"./pl.js": 174,
	"./pt": 176,
	"./pt-br": 175,
	"./pt-br.js": 175,
	"./pt.js": 176,
	"./ro": 177,
	"./ro.js": 177,
	"./ru": 178,
	"./ru.js": 178,
	"./sd": 179,
	"./sd.js": 179,
	"./se": 180,
	"./se.js": 180,
	"./si": 181,
	"./si.js": 181,
	"./sk": 182,
	"./sk.js": 182,
	"./sl": 183,
	"./sl.js": 183,
	"./sq": 184,
	"./sq.js": 184,
	"./sr": 186,
	"./sr-cyrl": 185,
	"./sr-cyrl.js": 185,
	"./sr.js": 186,
	"./ss": 187,
	"./ss.js": 187,
	"./sv": 188,
	"./sv.js": 188,
	"./sw": 189,
	"./sw.js": 189,
	"./ta": 190,
	"./ta.js": 190,
	"./te": 191,
	"./te.js": 191,
	"./tet": 192,
	"./tet.js": 192,
	"./tg": 193,
	"./tg.js": 193,
	"./th": 194,
	"./th.js": 194,
	"./tl-ph": 195,
	"./tl-ph.js": 195,
	"./tlh": 196,
	"./tlh.js": 196,
	"./tr": 197,
	"./tr.js": 197,
	"./tzl": 198,
	"./tzl.js": 198,
	"./tzm": 200,
	"./tzm-latn": 199,
	"./tzm-latn.js": 199,
	"./tzm.js": 200,
	"./ug-cn": 201,
	"./ug-cn.js": 201,
	"./uk": 202,
	"./uk.js": 202,
	"./ur": 203,
	"./ur.js": 203,
	"./uz": 205,
	"./uz-latn": 204,
	"./uz-latn.js": 204,
	"./uz.js": 205,
	"./vi": 206,
	"./vi.js": 206,
	"./x-pseudo": 207,
	"./x-pseudo.js": 207,
	"./yo": 208,
	"./yo.js": 208,
	"./zh-cn": 209,
	"./zh-cn.js": 209,
	"./zh-hk": 210,
	"./zh-hk.js": 210,
	"./zh-tw": 211,
	"./zh-tw.js": 211
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 361;

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","/Users/Seif/newchecker/vue2crm"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"/Users/Seif/newchecker/vue2crm","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(402),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(408),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  null,
  /* template */
  __webpack_require__(403),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(404),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(401),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(412),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d07c06fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(406),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(407),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(411),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(398),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(405),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 396:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    attrs: {
      "right": "",
      "disable-resize-watcher": true,
      "fixed": ""
    },
    model: {
      value: (_vm.rightDrawer),
      callback: function($$v) {
        _vm.rightDrawer = $$v
      },
      expression: "rightDrawer"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    staticClass: "my-2"
  }, [_c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("Modify Results")])], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-1 pt-3 ml-1",
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('cancelSearch')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("list")])], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('vue-progress-bar'), _vm._v(" "), (!_vm.loggedIn) ? [_c('router-view')] : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? [_c('v-navigation-drawer', {
    staticClass: "blue lighten-5",
    attrs: {
      "width": "250",
      "light": "",
      "mini-variant": _vm.mini,
      "app": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-content', [_c('br'), _vm._v("\n            Credits: " + _vm._s(_vm.user.credit) + "\n\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('v-menu', {
    attrs: {
      "bottom": "",
      "right": "",
      "offset-y": "",
      "origin": "bottom right",
      "transition": "v-slide-y-transition"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.userMenus), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "value": "true",
        "to": item.link,
        "router": ""
      }
    }, [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "router": ""
      },
      on: {
        "click": function($event) {
          _vm.clickMenu(item)
        }
      }
    }, [_c('v-list-tile-action', {
      staticClass: "pr-1 pl-2 mr-1"
    }, [_c('v-icon', {
      class: _vm.activeMenuItem.includes(item.title) ? 'blue--text' : '',
      attrs: {
        "title": item.title,
        "light": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', {
      class: _vm.activeMenuItem.includes(item.title) ? 'blue--text' : ''
    }, [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "app": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticStyle: {
      "justify-content": "center",
      "text-align": "center"
    },
    attrs: {
      "inset": true,
      "app": ""
    }
  }, [_c('span', [_vm._v("© " + _vm._s(_vm.pagetitle) + " 2018")])])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isPhoneView) ? _c('multipane', {
    staticClass: "vertical-panes",
    attrs: {
      "layout": "vertical"
    }
  }, [_c('div', {
    staticClass: "pane",
    style: ({
      width: '50%'
    })
  }, [_c('v-select', {
    attrs: {
      "name": "serviceid",
      "items": _vm.services,
      "disabled": _vm.DisableCheckComponents,
      "item-text": "displayname",
      "item-value": "id",
      "label": "Choose Service",
      "light": ""
    },
    on: {
      "change": function($event) {
        _vm.getChosenServiceDetails()
      }
    },
    model: {
      value: (_vm.chosenserviceid),
      callback: function($$v) {
        _vm.chosenserviceid = $$v
      },
      expression: "chosenserviceid"
    }
  }), _vm._v("\nService Name: " + _vm._s(_vm.chosenservice.name) + "\n"), _c('br'), _vm._v("\nService Description: "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.chosenservice.description)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showIMEIBox) ? _c('v-textarea', {
    attrs: {
      "disabled": _vm.DisableCheckComponents,
      "label": "IMEIs"
    },
    model: {
      value: (_vm.imeilist),
      callback: function($$v) {
        _vm.imeilist = $$v
      },
      expression: "imeilist"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showOrderButton) ? _c('toggle-button', {
    attrs: {
      "value": false,
      "disabled": _vm.DisableCheckComponents,
      "color": "#82C7EB",
      "width": 65,
      "sync": true,
      "labels": {
        checked: 'Instant',
        unchecked: 'Order'
      }
    },
    model: {
      value: (_vm.instantcheck),
      callback: function($$v) {
        _vm.instantcheck = $$v
      },
      expression: "instantcheck"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOrderButton) ? _c('v-btn', {
    attrs: {
      "disabled": _vm.DisableCheckComponents,
      "color": "info"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1), _vm._v(" "), _c('multipane-resizer'), _vm._v(" "), _c('div', {
    staticClass: "pane",
    style: ({
      flexGrow: 1
    })
  }, [(!_vm.instantcheck) ? _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearLog($event)
      }
    }
  }, [_vm._v("Clear Log")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n Progress: " + _vm._s(_vm.qtydone) + "/" + _vm._s(_vm.totalsubmitted) + "\n "), _c('div', {
    directives: [{
      name: "overflow-scroll",
      rawName: "v-overflow-scroll",
      value: (true),
      expression: "true"
    }],
    staticClass: "msg-container",
    attrs: {
      "scroll-to": "last-child"
    }
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('div', {
      staticClass: "msg"
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1) : _c('multipane', {
    staticClass: "horizontal-panes",
    attrs: {
      "layout": "horizontal"
    }
  }, [_c('div', {
    staticClass: "pane",
    style: ({
      width: '90%'
    })
  }, [_c('v-select', {
    attrs: {
      "name": "serviceid",
      "items": _vm.services,
      "item-text": "displayname",
      "item-value": "id",
      "label": "Choose Service",
      "light": ""
    },
    on: {
      "change": function($event) {
        _vm.getChosenServiceDetails()
      }
    },
    model: {
      value: (_vm.chosenserviceid),
      callback: function($$v) {
        _vm.chosenserviceid = $$v
      },
      expression: "chosenserviceid"
    }
  }), _vm._v("\nService Name: " + _vm._s(_vm.chosenservice.name) + "\n"), _c('br'), _vm._v("\nService Description: "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.chosenservice.description)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showIMEIBox) ? _c('v-textarea', {
    attrs: {
      "disabled": _vm.DisableCheckComponents,
      "label": "IMEIs"
    },
    model: {
      value: (_vm.imeilist),
      callback: function($$v) {
        _vm.imeilist = $$v
      },
      expression: "imeilist"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showOrderButton) ? _c('toggle-button', {
    attrs: {
      "value": false,
      "color": "#82C7EB",
      "width": "65",
      "sync": true,
      "labels": {
        checked: 'Instant',
        unchecked: 'Order'
      }
    },
    model: {
      value: (_vm.instantcheck),
      callback: function($$v) {
        _vm.instantcheck = $$v
      },
      expression: "instantcheck"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOrderButton) ? _c('v-btn', {
    attrs: {
      "disabled": _vm.DisableCheckComponents,
      "color": "info"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Submit Order")]) : _vm._e()], 1), _vm._v(" "), _c('multipane-resizer'), _vm._v(" "), _c('div', {
    staticClass: "pane",
    style: ({
      flexGrow: 1
    })
  }, [(!_vm.instantcheck) ? _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearLog($event)
      }
    }
  }, [_vm._v("Clear Log")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n Progress: " + _vm._s(_vm.qtydone) + "/" + _vm._s(_vm.totalsubmitted) + "\n "), _c('div', {
    directives: [{
      name: "overflow-scroll",
      rawName: "v-overflow-scroll",
      value: (true),
      expression: "true"
    }],
    staticClass: "msg-container",
    attrs: {
      "scroll-to": "last-child"
    }
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('div', {
      staticClass: "msg"
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1), _vm._v(" "), _c('confirm-dialog', {
    attrs: {
      "dialog": _vm.showDialog,
      "dialogTitle": _vm.dialogTitle,
      "dialogText": _vm.dialogText
    },
    on: {
      "onConfirm": _vm.onConfirm,
      "onCancel": _vm.onCancel
    }
  }), _vm._v(" "), (_vm.loading === false) ? _c('v-snackbar', {
    attrs: {
      "right": true,
      "timeout": _vm.timeout,
      "color": _vm.mode
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.notice) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    attrs: {
      "right": "",
      "disable-resize-watcher": true,
      "fixed": ""
    },
    model: {
      value: (_vm.rightDrawer),
      callback: function($$v) {
        _vm.rightDrawer = $$v
      },
      expression: "rightDrawer"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    staticClass: "my-2"
  }, [_c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("Advanced Search")])], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-1 pt-3 ml-1",
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    staticClass: "purple",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('searchData')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "grey",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('cancelSearch')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("clear")])], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "320"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.dialogTitle))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.dialogText))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('onConfirm')
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    staticClass: "orange--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('onCancel')
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "title"
  }, [_vm._v("API Settings")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm6": ""
    }
  }, [_c('b', [_vm._v("API Key")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.updateKey
    }
  }, [_vm._v("Update Key")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.disableapi
    }
  }, [_vm._v("Disable API")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "single-line": "",
      "outline": "",
      "readonly": "",
      "light": ""
    },
    model: {
      value: (_vm.apikey),
      callback: function($$v) {
        _vm.apikey = $$v
      },
      expression: "apikey"
    }
  }), _vm._v(" "), _c('b', [_vm._v("API IP")]), _vm._v(" "), _c('a', {
    ref: "changeipbutt",
    on: {
      "click": _vm.changeip
    }
  }, [_vm._v("Change IP")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.resetip
    }
  }, [_vm._v("Allow all")]), _vm._v(" "), _c('v-text-field', {
    ref: "ipbox",
    attrs: {
      "single-line": "",
      "outline": "",
      "readonly": _vm.editableip,
      "light": ""
    },
    model: {
      value: (_vm.apiip),
      callback: function($$v) {
        _vm.apiip = $$v
      },
      expression: "apiip"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "hover": "",
      "raised": ""
    }
  }, [_c('v-card-media', {
    staticClass: "pa-5 red lighten-1",
    attrs: {
      "height": "300px"
    }
  }, [_c('div', {
    staticClass: "display-1 white--text text-xs-center"
  }, [_vm._v(_vm._s(_vm.msg))])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multipane-resizer"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classnames,
    style: ({
      cursor: _vm.cursor,
      userSelect: _vm.userSelect
    }),
    on: {
      "mousedown": _vm.onMouseDown
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.idName
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._t("default", [_vm._v("\n\t\tDownload " + _vm._s(_vm.name) + "\n\t")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "title"
  }, [_vm._v("Order History")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.rightDrawer = !_vm.rightDrawer
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "brown lighten-1",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadData()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tablecontrols"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "idheader"
    },
    domProps: {
      "value": {
        "text": "#",
        "value": "id",
        "left": true
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "#",
        "value": "id",
        "left": true
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "#",
              "value": "id",
              "left": true
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "idheader"
    }
  }, [_vm._v("Order #")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "imeiheader",
      "checked": ""
    },
    domProps: {
      "value": {
        "text": "IMEI",
        "value": "imei"
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "IMEI",
        "value": "imei"
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "IMEI",
              "value": "imei"
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "imeiheader"
    }
  }, [_vm._v("IMEI")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "serviceheader"
    },
    domProps: {
      "value": {
        "text": "Service",
        "value": "Service"
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "Service",
        "value": "Service"
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "Service",
              "value": "Service"
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "serviceheader"
    }
  }, [_vm._v("Service")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "replyheader"
    },
    domProps: {
      "value": {
        "text": "Reply",
        "value": "reply"
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "Reply",
        "value": "reply"
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "Reply",
              "value": "reply"
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "replyheader"
    }
  }, [_vm._v("Reply")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "statusheader"
    },
    domProps: {
      "value": {
        "text": "Status",
        "value": "status"
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "Status",
        "value": "status"
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "Status",
              "value": "status"
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "statusheader"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "listidheader"
    },
    domProps: {
      "value": {
        "text": "List #",
        "value": "listid"
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "List #",
        "value": "listid"
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "List #",
              "value": "listid"
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "listidheader"
    }
  }, [_vm._v("List #")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "timeheader"
    },
    domProps: {
      "value": {
        "text": "Ordered On",
        "value": "time"
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "Ordered On",
        "value": "time"
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "Ordered On",
              "value": "time"
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "timeheader"
    }
  }, [_vm._v("Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "replytimeheader"
    },
    domProps: {
      "value": {
        "text": "Replied On",
        "value": "replytime"
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "Replied On",
        "value": "replytime"
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "Replied On",
              "value": "replytime"
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "replytimeheader"
    }
  }, [_vm._v("Reply Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "priceheader"
    },
    domProps: {
      "value": {
        "text": "Price",
        "value": "price"
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "Price",
        "value": "price"
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "Price",
              "value": "price"
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "priceheader"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headers),
      expression: "headers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "ipheader"
    },
    domProps: {
      "value": {
        "text": "IP",
        "value": "ip"
      },
      "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, {
        "text": "IP",
        "value": "ip"
      }) > -1 : (_vm.headers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.headers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = {
              "text": "IP",
              "value": "ip"
            },
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.headers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.headers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ipheader"
    }
  }, [_vm._v("IP")]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.loading === false) ? _c('Table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "pagination": _vm.pagination
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('search-panel', {
    attrs: {
      "rightDrawer": _vm.rightDrawer
    },
    on: {
      "cancelSearch": _vm.cancelSearch,
      "searchData": _vm.searchOrders
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "id",
      "label": "List",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.listid),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "listid", $$v)
      },
      expression: "searchVm.equals.listid"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "status",
      "items": _vm.statuss,
      "label": "Status",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.status),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "status", $$v)
      },
      expression: "searchVm.equals.status"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          Start Date: "), _c('datepicker', {
    attrs: {
      "format": _vm.customFormatter
    },
    model: {
      value: (_vm.searchVm.equals.start),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "start", $$v)
      },
      expression: "searchVm.equals.start"
    }
  }), _vm._v("\n          End Date: "), _c('datepicker', {
    attrs: {
      "format": _vm.customFormatter
    },
    model: {
      value: (_vm.searchVm.equals.end),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "end", $$v)
      },
      expression: "searchVm.equals.end"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "IMEIs"
    },
    model: {
      value: (_vm.searchVm.equals.imeilist),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "imeilist", $$v)
      },
      expression: "searchVm.equals.imeilist"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.loading === false) ? _c('v-snackbar', {
    attrs: {
      "right": true,
      "timeout": _vm.timeout,
      "color": _vm.mode
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.notice) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "title"
  }, [_vm._v("Work Jobs " + _vm._s(_vm.pagination ? "(" + _vm.pagination.totalItems + ")" : "") + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.rightDrawer = !_vm.rightDrawer
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "brown lighten-1",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadData()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "teal darken-2",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_c('v-icon', [_vm._v("print")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "deep-orange darken-3",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), (_vm.loading === false) ? _c('Table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "pagination": _vm.pagination
    },
    on: {
      "edit": _vm.edit
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('search-panel', {
    attrs: {
      "rightDrawer": _vm.rightDrawer
    },
    on: {
      "cancelSearch": _vm.cancelSearch,
      "searchData": _vm.searchOrders
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "id",
      "label": "Work Job",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.jobid),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "jobid", $$v)
      },
      expression: "searchVm.equals.jobid"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "custphone",
      "label": "Customer Phone",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.custphone),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "custphone", $$v)
      },
      expression: "searchVm.equals.custphone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "serialnumber",
      "label": "Serial Number",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.deviceid),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "deviceid", $$v)
      },
      expression: "searchVm.equals.deviceid"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "status",
      "items": _vm.statuss,
      "label": "Status",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.status),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "status", $$v)
      },
      expression: "searchVm.equals.status"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "techid",
      "items": _vm.techs,
      "item-text": "techname",
      "item-value": "techid",
      "label": "Technician",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.techid),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "techid", $$v)
      },
      expression: "searchVm.equals.techid"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.loading === false) ? _c('v-snackbar', {
    attrs: {
      "right": true,
      "timeout": _vm.timeout,
      "color": _vm.mode
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.notice) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-0 pt-0"
  }, [_c('v-card-title', {
    staticClass: "blue darken-1"
  }, [_c('h4', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.pagetitle))])]), _vm._v(" "), _c('v-card-text', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "name": "key",
      "label": "Key",
      "value": "Key"
    },
    model: {
      value: (_vm.key),
      callback: function($$v) {
        _vm.key = $$v
      },
      expression: "key"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("login")]), _vm._v(" "), (_vm.error) ? _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeout,
      "top": true,
      "multi-line": _vm.mode === 'multi-line',
      "vertical": _vm.mode === 'vertical'
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.text) + "\n                  "), _c('v-btn', {
    staticClass: "pink--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)])], 1), _vm._v(" "), (_vm.isH) ? _c('div', [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.iphonefile.com/IMEIMate.exe"
    }
  }, [_vm._v("Download Windows App")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://vimeo.com/339872408",
      "target": "_blank"
    }
  }, [_vm._v("Windows App Demo Video")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://hanggroup.com/imeimate/",
      "target": "_blank"
    }
  }, [_vm._v("Purchase Key (Credits)")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(" Available Services: ")]), _vm._v(" "), _c('br'), _vm._v("\n    iPhone Carrier Checker (Full Info)"), _c('br'), _vm._v("\n    iPhone Sim Lock Status"), _c('br'), _vm._v("\n    Find My iPhone ON/OFF by IMEI"), _c('br'), _vm._v("\n    Find My iPhone ON/OFF by SN"), _c('br'), _vm._v("\n    IMEI<->SN Converter"), _c('br'), _vm._v("\n    Activation Check By(IMEI/SN)"), _c('br'), _vm._v("\n    Full Coverage Check By(IMEI/SN)"), _c('br'), _vm._v("\n    iPhone/iPad iCloud Clean/Lost by IMEI"), _c('br'), _vm._v("\n    Sprint USA Pro Check"), _c('br'), _vm._v("\n    iPhone Carrier Checker"), _c('br'), _vm._v("\n    Sprint Unbarring (SPCS: Yes)"), _c('br'), _vm._v("\n    T-Mobile USA Status Check"), _c('br'), _vm._v("\n    WorldWide Clean/Blocked Check GSMA"), _c('br'), _vm._v("\n    Samsung Check\n"), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(" Contact: ")]), _vm._v(" "), _c('br'), _vm._v("\n      Skype: hangunlock "), _c('br'), _vm._v("\n      QQ: 2476715039 "), _c('br'), _vm._v("\n      Email: sales@hangunlock.com "), _c('br'), _vm._v("\n      WhatsApp / WeChat / iMessage: +85261942922 "), _c('br')]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_vm._l((props.headers), function(header, index) {
          return _c('th', {
            key: header.text,
            class: ['column', 'subheading', index === 0 ? 'text-xs-left' : 'text-xs-center']
          }, [_vm._v("\n              " + _vm._s(header.text) + "\n            ")])
        }), _vm._v(" "), _c('th')], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return _vm._l((_vm.headers), function(header, index) {
          return (header.value !== '') ? _c('td', {
            key: index,
            class: [index === 0 ? 'text-xs-left' : 'text-xs-center', 'body-2'],
            staticStyle: {
              "white-space": "pre"
            },
            domProps: {
              "innerHTML": _vm._s(_vm.renderData(props.item, header))
            }
          }) : _vm._e()
        })
      }
    }])
  }, [_c('template', {
    slot: "no-data"
  }, [_c('span', [_c('p', {
    staticClass: "pt-2 blue--text subheading"
  }, [_c('v-icon', {
    staticClass: "blue--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("info")]), _vm._v("Sorry, nothing to display here :(")], 1)])])], 2), _vm._v(" "), (_vm.isNotEmpty) ? _c('div', {
    staticClass: "text-xs-center pt-2"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pagination.pages,
      "total-visible": 5,
      "circle": ""
    },
    model: {
      value: (_vm.pagination.page),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "page", $$v)
      },
      expression: "pagination.page"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mx-0 pa-0",
    attrs: {
      "id": "dashboard",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('div', [_c('b', [_c('u', [_vm._v("Statistics")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-sm": "",
      "dark": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-0 mb-0 mx-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm9": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-2 mb-0 pa-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs15": ""
    }
  }, [_vm._v("\n                  User Balance: " + _vm._s(_vm.credits) + "\n                  ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 mb-0 pa-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs15": ""
    }
  }, [_c('div', {
    staticClass: "silver--text"
  }, [_vm._v("New Orders: " + _vm._s(_vm.orders.new))]), _vm._v(" "), _c('div', {
    staticClass: "silver--text"
  }, [_vm._v("Processing Orders: " + _vm._s(_vm.orders.processing))]), _vm._v(" "), _c('div', {
    staticClass: "silver--text"
  }, [_vm._v("Rejected Orders: " + _vm._s(_vm.orders.rejected))]), _vm._v(" "), _c('div', {
    staticClass: "silver--text"
  }, [_vm._v("Success Orders: " + _vm._s(_vm.orders.replied))]), _vm._v(" "), _c('div', {
    staticClass: "silver--text"
  }, [_vm._v("Total Count: " + _vm._s(_vm.orders.total))])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('vue-custom-scrollbar', {
    staticClass: "scroll-area"
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "title"
  }, [_vm._v("Results Parser")])]), _vm._v("\n            You can merge between results of 2 services here and export to excel as well\n            "), _c('br'), _vm._v("\n            e.g. Check the same IMEI on simlock & FMI and get an excel sheet for both results in the same row\n            "), _c('br'), _vm._v("\n            Click on any header to sort the data\n"), _c('br'), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "outline": "",
      "placeholder": "list1,list2 Get it from List# in history",
      "label": "List",
      "light": ""
    },
    model: {
      value: (_vm.lists),
      callback: function($$v) {
        _vm.lists = $$v
      },
      expression: "lists"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "blue-grey",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.fetchOrders
    }
  }, [_vm._v("Parse")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.rightDrawer = !_vm.rightDrawer
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm3": "",
      "md1": ""
    }
  }, [_c('download-excel', {
    attrs: {
      "data": _vm.sortedItems,
      "type": "csv",
      "fields": _vm.excelHeaders,
      "name": _vm.getFileName()
    }
  }, [_c('v-btn', {
    staticClass: "blue-grey",
    attrs: {
      "flat": "flat"
    }
  }, [_vm._v("Export")])], 1)], 1), _vm._v(" "), _c('parser-panel', {
    attrs: {
      "rightDrawer": _vm.rightDrawer
    },
    on: {
      "cancelSearch": _vm.cancelSearch
    }
  }, _vm._l((_vm.fullheaders), function(header) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.headers),
        expression: "headers"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": header,
        "checked": Array.isArray(_vm.headers) ? _vm._i(_vm.headers, header) > -1 : (_vm.headers)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.headers,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = header,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.headers = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.headers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.headers = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(header) + "\n    ")])
  }))], 1), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('thead', _vm._l((_vm.headers), function(header) {
    return _c('th', {
      class: {
        sorted: _vm.sort === header
      },
      on: {
        "click": function($event) {
          _vm.sortBy(header)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(header) + " ")])])
  })), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedItems), function(item) {
    return _c('tr', {
      staticStyle: {
        "border": "solid"
      },
      attrs: {
        "border": "1"
      }
    }, _vm._l((_vm.headers), function(header) {
      return _c('td', [_vm._v(_vm._s(item[header]))])
    }))
  }))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.allowed) ? _c('div', [_vm._m(0), _vm._v(" "), _c('br'), _vm._v("\nPlease send the payment to "), _c('b', [_vm._v("paypal@unlocklounge.com")]), _vm._v(" and paste the transaction id below\n"), _c('br'), _vm._v("\n*Gift or mass "), _c('b', [_vm._v("ONLY")]), _vm._v("!\n"), _c('div', {
    staticClass: "paymentdiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txnid),
      expression: "txnid"
    }],
    attrs: {
      "placeholder": "Please enter transaction id"
    },
    domProps: {
      "value": (_vm.txnid)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.txnid = $event.target.value
      }, _vm.txnidLength]
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.showSubmitButton,
      "color": "info"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitPayment($event)
      }
    }
  }, [_vm._v("Process Payment")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serverResponse)
    }
  })], 1)]) : _c('div', [_vm._v("\nPlease contact your reseller to add credits\n")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "10",
      "cellspacing": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.paypal.com/eg/webapps/mpp/paypal-popup",
      "title": "How PayPal Works",
      "onclick": "javascript:window.open('https://www.paypal.com/eg/webapps/mpp/paypal-popup','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png",
      "border": "0",
      "alt": "PayPal Logo"
    }
  })])])])])
}]}

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(400),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_orders__ = __webpack_require__(240);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()({ storage: window.sessionStorage })],
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    orders: __WEBPACK_IMPORTED_MODULE_4__modules_orders__["a" /* default */]
  }
}));

/***/ })

},[239]);


// WEBPACK FOOTER //
// assets/js/app.518be2ca6f442ccd0e3a.js